import { useAuthorization } from "@common/providers";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import { Route, Routes } from "react-router";
import Show from "./Show";
import {
  useV2GetAccountQuery,
  useV2GetProjectByIdQuery,
} from "@generated";
import usePrivilegeCheck from "@common/hooks/usePrivilegeCheck";
import Edit from "./Edit/Edit";
import New from "./New/New";
import useFlags from "@common/hooks/useFlags";

const VendorQuotesV2Mspa = ({ project_id }): JSX.Element => {
  // Get Account
  const { data: account, isLoading: accountLoading } = useV2GetAccountQuery({
    include: ["phases", "resources"],
  });

  // Get Project with included items
  const { data: project, isLoading: projectLoading } = useV2GetProjectByIdQuery({
    id: String(project_id),
    include: [
      "project-phases",
      "payment-term",
      "project-resources",
      "project-services",
      "rate-table",
      "quotes",
    ],
  });

  // Get permissions for current user
  const { accessLevel, privilegesLoading } = usePrivilegeCheck();

  const authorized = useAuthorization();

  const permissions = {
    quotes: accessLevel("projects.vendor_quotes"),
    vendors: accessLevel("settings.vendors"),
  };

  const { configVendorQuoteRevenueCalculation } = useFlags();

  if (!authorized || accountLoading || privilegesLoading || projectLoading) {
    return <ScopeStackSpinner />;
  }

  const labels = {
    quote:
      account?.data?.attributes?.["field-labels"]?.["vendor_quote"] ||
      "Vendor Quote",
    resource:
      account?.data?.attributes?.["field-labels"]?.["vendor_resource"] ||
      "Vendor Resource",
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Show
            project_id={project_id}
            account={account}
            permissions={permissions}
            project={project}
            revenueCalculationLabel={configVendorQuoteRevenueCalculation}
            labels={labels}
          />
        }
      />
      <Route
        path="/edit/:quoteId"
        element={
          <Edit
            project_id={project_id}
            account={account}
            permissions={permissions}
            project={project}
            revenueCalculationLabel={configVendorQuoteRevenueCalculation}
            labels={labels}
          />
        }
      />
      <Route
        path="/new"
        element={
          <New
            project_id={project_id}
            account={account}
            permissions={permissions}
            project={project}
            revenueCalculationLabel={configVendorQuoteRevenueCalculation}
            labels={labels}
          />
        }
      />
    </Routes>
  );
};

export default VendorQuotesV2Mspa;
